module.exports = __webpack_public_path__ + "img/stopwatch.2b8d3975.svg";